import { useReducer } from 'react';
import { GlobalContext } from './GlobalContext';

const win: any = window;
let login_type;
let return_url;

if (window.location.href.includes("localhost")) {
    !!!win['errorPageUrl'] && (win['errorPageUrl'] = `http://ssta004:8080/wps/portal/web/personal/store/error`);
    !!!win["easyLoginPageURL"] && (win["easyLoginPageURL"] = `${window.location.origin}`);
    login_type = new URL(window.location.href).searchParams.get("login-type");
    return_url = window.location.search.length > 0 ? window.location.search.split("returnUrl=")[1] : '';
} else {
    !!!win['errorPageUrl'] && (win['errorPageUrl'] = `${window.location.origin}/wps/portal/web/personal/store/error`);
    !!!win["easyLoginPageURL"] && (win["easyLoginPageURL"] = `${window.location.origin}${window.location.pathname}`);
    const billInfoStr = localStorage.getItem('bill_info');
    const bill_info = billInfoStr ? JSON.parse(billInfoStr) : null;
    login_type = bill_info && bill_info['login-type'];
    return_url = bill_info && bill_info.returnUrl;
}

const lang = document.documentElement.lang;
const rtl = lang === 'ar';
!!!win["lang"] && (win["lang"] = lang);

const account_type = new URL(window.location.href).searchParams.get("accType");

let otpType = '';
let userType = '';
let bothType = '';
let accountType = '';

if (login_type) {
    if (login_type === 'otp') otpType = login_type;
    if (login_type === 'user') userType = login_type;
    if (login_type === 'both') bothType = login_type;
}

if (account_type) accountType = account_type;

const initialState = {
    loading: false,
    rtl: rtl,
    otpType: otpType,
    userType: userType,
    bothType: bothType,
    msisdn: "",
    otpToken: "",
    returnUrl: return_url,
    loginActive: true,
    accountType
}

const reducer = (state: any, action: any) => {
    switch (action.type) {
        case "LOADER":
            return {
                ...state,
                loading: action.payload.loading
            }
        case "MSISDN":
            return {
                ...state,
                msisdn: action.payload.msisdn,
                otpToken: action.payload.otpToken
            }
        case "USERNAME_PASSWORD":
            return {
                ...state,
                otpToken: action.payload.otpToken
            }

        case "LOGIN_ACTIVE":
            return {
                ...state,
                loginActive: action.payload.active
            }

        default:
            return state;
    }
}

export const GlobalProvider = (props: any) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    return (
        <GlobalContext.Provider value={{ state, dispatch }}>
            {props.children}
        </GlobalContext.Provider>
    )
}